import React, { memo, useMemo } from 'react'
import dayjs from 'dayjs'
import classNames from 'classnames'
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation'

import { ListingPositionEnum } from './types'
import type { ScheduleProps } from './types'

const Schedule = ({
  data,
  position,
  onFocus,
  scheduleRange,
  channel,
  hoursToDisplay,
}: ScheduleProps) => {
  const { ref, focused } = useFocusable({
    onFocus,
    extraProps: { channel, listing: data },
  })

  const width = useMemo<number>(() => {
    const totalMinutes = hoursToDisplay * 60
    if (scheduleRange) {
      if (
        position === ListingPositionEnum.startsBeforeScheduleStartButNotEnded
      ) {
        const minsPlayed = scheduleRange.start.diff(
          dayjs(data.start_time),
          'minute'
        )
        return ((data.duration / 60 - minsPlayed) / totalMinutes) * 100
      }

      if (position === ListingPositionEnum.duringScheduleEndsAfterScheduleEnd) {
        return (
          (scheduleRange.end.diff(dayjs(data.start_time), 'minute') /
            totalMinutes) *
          100
        )
      }
    }

    return ((data.duration < 60 ? 60 : data.duration) / 60 / totalMinutes) * 100
  }, [scheduleRange])

  const style = useMemo(
    () =>
      ({
        '--dynamic-schedule-width': `${width}%`,
      } as React.CSSProperties),
    [width]
  )

  return (
    <div
      style={style}
      className={classNames('epg__schedule', {
        'epg__schedule--hidden-at-start':
          position === ListingPositionEnum.hiddenAtStart,
        'epg__schedule--hidden-at-end':
          position === ListingPositionEnum.hiddenAtEnd,
      })}
    >
      <div className="epg__schedule-wrapper">
        <div
          className={classNames('epg__schedule-overlay', {
            'epg__schedule-overlay--focused':
              focused && position !== ListingPositionEnum.hiddenAtStart,
          })}
        ></div>
        <div ref={ref} className={`epg__schedule-content`}>
          <p
            className={classNames('epg__schedule-content-text', {
              'epg__schedule-content-text--3-dots': width <= 5,
            })}
          >
            {width <= 5 ? '...' : data.show_title}
          </p>
        </div>
      </div>
    </div>
  )
}

export default memo(Schedule)
